// @flow weak

import { includes, isFunction } from 'lodash';

import {
  type SideEffect,
  type SideEffectProps,
  type SideEffectRegistry,
  sideEffect,
} from 'app/common/SideEffects';

import type { Dispatch } from 'redux';

type GetState = () => {};

type Action = {
  type: $Subtype<string>,
};

type Store = {
  dispatch: Dispatch<Action>,
  getState(): {},
};

type ReduxSideEffectCallback = ({
  state: GetState,
  action: Action,
  dispatch: Dispatch<Action>,
}) => void;

type ReduxSideEffectProps = SideEffectProps<ReduxSideEffectCallback>;

export const reduxSideEffect = (props: ReduxSideEffectProps) =>
  sideEffect<ReduxSideEffectCallback>(props);

const shouldSideEffectRun = (effect: SideEffect, action: Action) =>
  includes(effect.when, action.type) && isFunction(effect.then);

const runSideEffect = (store: Store, action: Action, effect: SideEffect) => {
  setTimeout(() => {
    effect.then({
      getState: store.getState,
      action,
      dispatch: store.dispatch,
    });
  }, 0);
};

const runSideEffectsOnAction = (
  store: Store,
  action: Action,
  effects: Array<SideEffect>
) => {
  effects.forEach(effect => {
    if (shouldSideEffectRun(effect, action)) {
      runSideEffect(store, action, effect);
    }
  });
};

export const createMiddleware = (
  registry: SideEffectRegistry
) => store => next => action => {
  runSideEffectsOnAction(store, action, registry.effects);

  return next(action);
};
